import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { useDeliveryItemContext } from "../../context/deliveryItem.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    const { option } = useDeliveryItemContext();

    if (option.deliveryType !== DeliveryType.HomeDelivery) {
        return null;
    }

    return <div className={cn("tw:pl-5.25", className)}>{children}</div>;
};
